'use client'

import type { QuantitySelectorProps } from '@pearlconvert/ui/components/quantity-selector/quantity-selector.types'

import classNames from 'classnames'

import { theme } from '@maestro/local/theme'
import { ErrorMessage } from '@pearlconvert/ui/components/error-message'
import { useQuantitySelector } from '@pearlconvert/ui/components/quantity-selector/batons/use-quantity-selector'

import '@pearlconvert/ui/components/quantity-selector/styles/quantity-selector.scss'

export default function QuantitySelector(props: QuantitySelectorProps) {
  const {
    id,
    value,
    minusDisabled,
    plusDisabled,
    disabled,
    controlSize,
    className,
    messageClassName,
    error,
    quantityLabel,
    decreaseLabel,
    increaseLabel,
    testIdPrefix,
    blurFallback,
    onChange,
  } = props

  const { displayValue, handleChange, handleBlur, decrement, increment } =
    useQuantitySelector({ value, blurFallback, onChange })

  // Polar: the input fits every digit of the quantity cap (POL-212).
  const maxDigits = String(theme().cms.quantityCounterMaxValue).length

  return (
    <>
      <div
        className={classNames(
          'qty',
          { [`qty--${controlSize}`]: controlSize },
          className
        )}
      >
        <button
          type="button"
          data-testid={`${testIdPrefix}-minus`}
          className="qty__button qty__button--dec"
          onClick={decrement}
          disabled={disabled || minusDisabled}
          aria-label={decreaseLabel}
        />
        <label htmlFor={`field-quantity-${id}`} className="sr-only">
          {quantityLabel}
        </label>
        <input
          inputMode="numeric"
          value={displayValue}
          maxLength={maxDigits}
          size={maxDigits}
          id={`field-quantity-${id}`}
          disabled={disabled}
          className={classNames('qty__field', {
            'qty__field--error': !!error,
          })}
          onChange={(event) => handleChange(event.currentTarget.value)}
          onBlur={handleBlur}
        />
        <button
          type="button"
          data-testid={`${testIdPrefix}-plus`}
          className="qty__button qty__button--inc"
          onClick={increment}
          disabled={disabled || plusDisabled}
          aria-label={increaseLabel}
        />
      </div>
      {error && (
        <ErrorMessage className={classNames('qty__message', messageClassName)}>
          {error}
        </ErrorMessage>
      )}
    </>
  )
}
